(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.SelectYearAndCropController = (function(superClass) {
    extend(SelectYearAndCropController, superClass);

    function SelectYearAndCropController(scope, transitions, repo) {
      this.scope = scope;
      this.transitions = transitions;
      this.repo = repo;
      this.isSppSelected = bind(this.isSppSelected, this);
      this.toggleSpp = bind(this.toggleSpp, this);
      this.isYearSelected = bind(this.isYearSelected, this);
      this.toggleYear = bind(this.toggleYear, this);
      this.canContinue = bind(this.canContinue, this);
      this.next = bind(this.next, this);
      this.sanityCheck = bind(this.sanityCheck, this);
      this.loadYearsAndSpps = bind(this.loadYearsAndSpps, this);
      SelectYearAndCropController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.step.title = 'Select Year and Crop';
      this.scope.step.previous = function() {
        return void 0;
      };
      this.scope.step.next = this.next;
      this.scope.step.canContinue = this.canContinue;
      this.scope.year_placeholder = 'Loading survey years...';
      this.scope.years = [];
      this.scope.toggleYear = this.toggleYear;
      this.scope.isYearSelected = this.isYearSelected;
      this.scope.spp_placeholder = 'Loading survey crops...';
      this.scope.spps = [];
      this.scope.toggleSpp = this.toggleSpp;
      this.scope.isSppSelected = this.isSppSelected;
      this.input_changed = false;
      this.scope.$watchCollection('selected.years', (function(_this) {
        return function(val, old_val) {
          if (val !== old_val) {
            return _this.input_changed = true;
          }
        };
      })(this));
      this.scope.$watchCollection('selected.spps', (function(_this) {
        return function(val, old_val) {
          if (val !== old_val) {
            return _this.input_changed = true;
          }
        };
      })(this));
      this.loadYearsAndSpps();
    }

    SelectYearAndCropController.prototype.loadYearsAndSpps = function() {
      return this.repo.getYearsAndSpps().then((function(_this) {
        return function(result) {
          var ref, ref1, ref2;
          if (((ref = result.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0) !== 'success') {
            if (((ref2 = result.data) != null ? ref2.status : void 0) != null) {
              _this.scope.$parent.setAlert(result.data.status);
            } else {
              _this.scope.$parent.setAlert({
                type: 'error',
                msg: 'Failed to load survey years and crops'
              });
            }
            return;
          }
          _this.scope.years = result.data.data.years;
          if (_this.scope.years.length === 0) {
            _this.scope.year_placeholder = 'No survey years found';
          } else {
            if (_this.scope.selected.years.length === 0) {
              _this.toggleYear(_this.scope.years[0]);
            }
          }
          _this.scope.spps = result.data.data.spps;
          if (_this.scope.spps.length === 0) {
            _this.scope.spp_placeholder = 'No survey crops found';
          } else {
            if (_this.scope.selected.spps.length === 0 && _this.scope.spps.length === 1) {
              _this.toggleSpp(_this.scope.spps[0]);
            }
          }
          return _this.sanityCheck();
        };
      })(this), (function(_this) {
        return function() {
          return _this.scope.$parent.setAlert({
            type: 'error',
            msg: 'Failed to load survey years and crops'
          });
        };
      })(this));
    };

    SelectYearAndCropController.prototype.sanityCheck = function() {
      var j, k, ref, ref1, results, spp, year;
      ref = this.scope.selected.years;
      for (j = ref.length - 1; j >= 0; j += -1) {
        year = ref[j];
        if (this.scope.years.indexOf(year) === -1) {
          this.toggleYear(year);
        }
      }
      ref1 = this.scope.selected.spps;
      results = [];
      for (k = ref1.length - 1; k >= 0; k += -1) {
        spp = ref1[k];
        if (_.findIndex(this.scope.spps, {
          id: spp.id
        }) === -1) {
          results.push(this.toggleSpp(spp));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    SelectYearAndCropController.prototype.next = function() {
      this.scope.$parent.clearAlert();
      if (this.input_changed) {
        this.scope.selected.survey_results = [];
      }
      return this.scope.goToStep('select_surveys');
    };

    SelectYearAndCropController.prototype.canContinue = function() {
      return this.scope.selected.years.length > 0 && this.scope.selected.spps.length > 0;
    };

    SelectYearAndCropController.prototype.toggleYear = function(year) {
      var i;
      i = this.scope.selected.years.indexOf(year);
      if (i === -1) {
        return this.scope.selected.years.push(year);
      } else {
        return this.scope.selected.years.splice(i, 1);
      }
    };

    SelectYearAndCropController.prototype.isYearSelected = function(year) {
      return this.scope.selected.years.indexOf(year) > -1;
    };

    SelectYearAndCropController.prototype.toggleSpp = function(spp) {
      var i;
      i = _.findIndex(this.scope.selected.spps, {
        id: spp.id
      });
      if (i === -1) {
        return this.scope.selected.spps.push(spp);
      } else {
        return this.scope.selected.spps.splice(i, 1);
      }
    };

    SelectYearAndCropController.prototype.isSppSelected = function(spp) {
      return _.findIndex(this.scope.selected.spps, {
        id: spp.id
      }) > -1;
    };

    return SelectYearAndCropController;

  })(Controller);

}).call(this);
